import {
  FulfillmentLifecycleStatus,
  FulfillmentLineExceptionType,
  FulfillmentLineStatus,
  OrderType,
} from './types';

export const FULFILLMENT_PAGE_SIZE = 15;

export const LIFECYCLE_STATUSES: FulfillmentLifecycleStatus[] = [
  'pending',
  'picking',
  'picked',
  'packing',
  'packed',
  'shipped',
  'cancelled',
];

export const LINE_STATUSES: FulfillmentLineStatus[] = [
  'pending',
  'quality-check',
  'picked',
  'packed',
  'exception',
];

export const EXCEPTION_TYPES: { value: FulfillmentLineExceptionType; label: string }[] = [
  { value: 'item_not_found', label: 'Item not found' },
  { value: 'item_damaged', label: 'Item damaged' },
  { value: 'skip', label: 'Skip' },
  { value: 'other', label: 'Other' },
];

export const ORDER_TYPE_LABELS: Record<OrderType, string> = {
  bike_only: 'Bike only',
  paa_only: 'PA&A only',
  mixed: 'Mixed',
  unknown: '—',
};

export const LIFECYCLE_STATUS_LABELS: Record<FulfillmentLifecycleStatus, string> = {
  pending: 'Pending',
  picking: 'Picking',
  picked: 'Picked',
  packing: 'Packing',
  packed: 'Packed',
  shipped: 'Shipped',
  cancelled: 'Cancelled',
};

export const LIFECYCLE_STATUS_COLORS: Record<
  FulfillmentLifecycleStatus,
  { bg: string; color: string }
> = {
  pending: { bg: '#eeeeee', color: '#616161' },
  picking: { bg: '#c9e1f2', color: '#0163b0' },
  picked: { bg: '#e7fbf1', color: '#009320' },
  packing: { bg: '#ffedd5', color: '#c2410c' },
  packed: { bg: '#00c160', color: '#ffffff' },
  shipped: { bg: '#01741e', color: '#ffffff' },
  cancelled: { bg: '#e0e0e0', color: '#757575' },
};
